// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const IconAnchorSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M12 3C11.1716 3 10.5 3.67157 10.5 4.5C10.5 5.32843 11.1716 6 12 6C12.8284 6 13.5 5.32843 13.5 4.5C13.5 3.67157 12.8284 3 12 3ZM9.5 4.5C9.5 3.11929 10.6193 2 12 2C13.3807 2 14.5 3.11929 14.5 4.5C14.5 5.70948 13.6411 6.71836 12.5 6.94999V9H15V10H12.5V19H14.4269C14.6729 19 14.9103 18.9093 15.0937 18.7452L19.0227 15.2298L18.7929 15H17V14H18.7929C19.0581 14 19.3125 14.1054 19.5 14.2929L20.7071 15.5C20.8946 15.6875 21 15.9419 21 16.2071V18H20V16.2071L19.7309 15.938L15.7605 19.4905C15.3938 19.8186 14.919 20 14.4269 20H9.5731C9.08102 20 8.60622 19.8186 8.23951 19.4905L4.2691 15.938L4 16.2071V18H3V16.2071C3 15.9419 3.10536 15.6875 3.29289 15.5L4.5 14.2929C4.68754 14.1054 4.94189 14 5.20711 14H7V15H5.20711L4.97729 15.2298L8.9063 18.7452C9.08966 18.9093 9.32706 19 9.5731 19H11.5V10H9V9H11.5V6.94999C10.3589 6.71836 9.5 5.70948 9.5 4.5Z" />
    </svg>
  )
}
